let tautocompleteSettings = [];
let hasClickedViewNetworkContractButton = false;

(function ($) {
    "use strict";
    $.fn.tautocomplete = function (options, callback) {     // NOSONAR (complaining about too many lines - this function was largely copied from legacy code and it's too risky to refactor)
        let _LOG_COLOR = 'goldenrod';

        function _logDebug(message, object) {
            DevUtils.logDebug(message, 'A11yTAutocomplete --> $.fn.tautocomplete()', object, _LOG_COLOR);
        }

        function _logVerbose(message, object) {
            DevUtils.logVerbose(message, 'A11yTAutocomplete --> $.fn.tautocomplete()', object);
        }

        function clearSearchField(inputElem) {
            $(inputElem).attr('title', '');
            $(inputElem).data('id', '');
            $(inputElem).val('');
            This.onChange($(inputElem)[0]);
        }

        /*
         * Function to retrieve the stored jquery plugin settings from the object. We need to store this and
         * retrieve it like this because there are use cases where the original settings are no longer in
         * context and therefore not available (and we end up retrieving the wrong settings if there are
         * multiple tautocomplete's on the same screen)
         */
        function _getSettings(curObj) {
            let settings;
            let storageId = $(curObj).attr('id');
            let supplementalId = $(curObj).attr('data-supplemental-id');

            if (supplementalId) {
                storageId += supplementalId;
            }

            _logDebug('getting settings object for ID [' + storageId + ']', { curObj: curObj, tautocompleteSettings: tautocompleteSettings });

            // FETCH SETTINGS FROM MEMORY
            if (storageId) {
                settings = tautocompleteSettings[storageId];
            } else {
                DevUtils.logError('cannot fetch settings, storageId is null', 'A11yTAutocomplete.getSettings()');
            }

            if (settings) {
                _logDebug('A11yTAutocomplete.getSettings(): found settings object for ID [' + storageId + ']', { curObj: curObj, settings: settings });
            } else {
                DevUtils.logError('cannot find settings for storageId [' + storageId + ']', 'A11yTAutocomplete.getSettings()');
            }

            return settings;
        }

        /*
        * Function to retrieve the stored jquery plugin settings from the object. We need to store this and
        * retrieve it like this because there are use cases where the original settings are no longer in
        * context and therefore not available (and we end up retrieving the wrong settings if there are
        * multiple tautocomplete's on the same screen)
        */
        function _storeSettings(curObj, settings) {
            let storageId = $(curObj).attr('id');

            if (settings.supplementalId && settings.supplementalId !== '') {
                storageId += settings.supplementalId;
                $(curObj).attr('data-supplemental-id', settings.supplementalId);
            }

            _logDebug('storing settings object for ID [' + storageId + ']', { curObj: curObj, settings: settings });

            // STORE SETTINGS IN MEMORY
            if (storageId) {
                tautocompleteSettings[storageId] = settings;
            } else {
                DevUtils.logError('cannot store settings, storageId is null', 'A11yTAutocomplete.storeSettings()');
            }
        }

        function isDivHeightVisible(elem) {
            let docViewTop, docViewBottom, elemTop, elemBottom;
            let isModal = $(elem).closest('.ah-modal').length > 0;

            if (isModal) {
                let modalElem = $(elem).closest('.ah-modal');
                docViewTop = $(modalElem).scrollTop();
                docViewBottom = docViewTop + $(modalElem).height();

                elemTop = $(elem).offset().top;
                elemBottom = elemTop + $(elem).height();
            } else {
                docViewTop = $(window).scrollTop();
                docViewBottom = docViewTop + $(window).height();

                elemTop = $(elem).offset().top;
                elemBottom = elemTop + $(elem).height();
            }

            return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom)
                && (elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function isDivWidthVisible(elem) {
            let docViewLeft = $(window).scrollLeft();
            let docViewRight = docViewLeft + $(window).width();

            let modal = $(elem).closest('.ah-modal');
            if ($(modal).length > 0) {
                docViewLeft = $(modal).offset().left;
                docViewRight = docViewLeft + $(modal).width();
            }

            let elemLeft = $(elem).offset().left;
            let elemRight = elemLeft + $(elem).width();

            return ((elemRight >= docViewLeft) && (elemLeft <= docViewRight)
                && (elemRight <= docViewRight) && (elemLeft >= docViewLeft));
        }

        // default parameters
        let settings = $.extend({
            width: "300px",
            columns: [],
            hide: [false],
            onchange: null,
            norecord: "No Records Found",
            dataproperty: null,
            data: null,
            ajax: null,
            columnToSelectText: "",
            columnToSelectId: "",
            tabEnabledColumn: "",
            delay: 1000,
            disclaimerHtml: "",
            noteHtml: "",
            focusinCallback: null,
            focusoutCallback: null,
            highlight: 'word-highlight',
            minChar: 3,
            searchFilter: "",

            // add'l params for a11y:
            dataType: '',
            instructionalText: 'Use the Tab or Shift-Tab key to navigate search results with keyboard',
            supplementalId: ''
        }, options);

        _logDebug('constructing tautocomplete for ID [' + $(this).attr('id') + ']', { options: options, callback: callback, settings: settings });

        //initialize DOM elements
        let el = {};
        let isSearch = true;
        let This = this;
        let keyCodes = [13, 9, 8, 38, 40, 110, 190, 189, 27];
        let errors = {
            columnNA: "Error: Columns Not Defined",
            dataNA: "Error: Data Not Available",
            TabVldtn: "please enter correct code otherwise use search to select code"
        };
        let dataList = [];
        // plugin properties
        let curTxtBx;
        let tautocomplete = {

            id: function () {
                return $(curTxtBx).data("id");
            },
            text: function () {
                return $(curTxtBx).attr("title");
            },
            currentTextBoxObj: function () {
                return $(curTxtBx);
            },
            searchdata: function () {
                return $(curTxtBx).val();
            },
            settext: function (text) {
                $(curTxtBx).val(text);
                $(curTxtBx).attr("title", text);
            },
            setTitle: function (text) {
                $(curTxtBx).attr("title", text);
            },
            setId: function (id) {
                $(curTxtBx).data("id", id);
            },
            isNull: function () {
                return $(curTxtBx).attr("title") === "" || $(curTxtBx).attr("title") == null;
            },
            all: function () {
                return selectedData;
            }
        };

        // delay function which listens to the textbox entry
        let delay = (function () {      // NOSONAR - not sure what this is for but sonar complaining about it being useless
            let timer = 0;
            return function (callsback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callsback, ms);
            };
        })();

        let selectedData = {};

        let focused = false;
        let IsTab = false;
        // check if the textbox is focused.
        if (this.is(':focus')) {
            focused = true;
        }

        let IsAg = window.top.$("#MvcMainBody .InComplaintPage").length > 0;

        This.each(function () {
            if (settings.searchFilter !== "" && $(this).closest('.ProviderDiv').find('#' + providerQuickSearchFiltertype.checkBoxId).length === 0 && settings.searchFilter.expand) {
                // "filterTypeTemplate" is a global var defined in ProviderQuickSearch.js (it is a DIV containing the "Expanded Search" checkbox for provider smart searches)
                if (IsAg) {
                    $(this).closest('.AgProviderDiv').find('.ah-ta-container').before(filterTypeTemplate.expand);
                } else {
                    $(this).closest('div.custDrop.clear').length === 0 ? $(this).closest('td').append(filterTypeTemplate.expand) : $(this).closest('div.custDrop.clear').before(filterTypeTemplate.expand);
                }
            }
        });
        // get number of columns
        let cols = settings.columns.length;
        let srchValb4Tab = "";

        This.attr("autocomplete", "off");
        This.css("width", this.width + "px");
        This.css("font-size", this.css("font-size"));
        This.attr("placeholder", settings.placeholder);

        // check for mandatory parameters
        if (settings.columns && settings.columns.length === 0) {
            This.attr("placeholder", errors.columnNA);
        } else if ((settings.data === "" || settings.data == null) && settings.ajax == null) {
            This.attr("placeholder", errors.dataNA);
        } else {
            // do nothing, this is here for Sonar
        }

        if (settings.columnToSelectText === "" || settings.columnToSelectText == null) {
            settings.columnToSelectText = settings.columns[0][1];
        }

        if (settings.columnToSelectId === "" || settings.columnToSelectId == null) {
            settings.columnToSelectId = settings.columns[0][0];
        }

        if (settings.selectedId !== 0 && settings.selectedText !== "") {
            This.val(settings.selectedText);
            $(This).val(settings.selectedId);
        }

        if (focused) {
            This.focus();
        }

        // A11Y FIXES
        $(This).each(function (index, element) {
            _storeSettings(element, settings);

            let elementId = $(element).attr('id') + (settings.supplementalId ? settings.supplementalId : '');
            let uniqueId = $(element).attr('data-unique-id') ? $(element).attr('data-unique-id') : '';

            // tag the input element as being a tautocomplete element
            $(element).addClass('ah-ta-input');

            // add sr-only instructional text
            let instrId = (uniqueId !== '' ? uniqueId : elementId) + 'SrInstructions';

            if ($('#' + instrId).length === 0 && $(element).closest('.ah-ta-container').find('.sr-only').length === 0) {
                safeFind(element).before('<span id="' + instrId + '" class="sr-only">Press enter key after typing first 3 characters to trigger search</span>');
                $(element).attr('aria-describedby', instrId);
            }

            // add the search button + the search button event handler
            let searchButtonId = (uniqueId !== '' ? uniqueId : elementId) + 'Search';

            if ($('#' + searchButtonId).length === 0 && $(element).closest('.ah-ta-container').find('.ah-ta-search-btn').length === 0) {
                // NOTE: The search button caused a lot of problems... it was only added for a11y, and for now we are hiding it in hopes that we pass a11y audit without it.
                //       Leaving code in place (but setting display:none) for reference and in case we need to add it back in later after a11y audits
                safeFind(element).after('<button id="' + searchButtonId + '" class="ah-btn-link ah-ta-search-btn" style="display:none;" aria-label="search"><i class="far fa-search"></i></button>');

                let leftOffset = 0;
                if ($(element).hasClass('ah-input')) {
                    leftOffset = 5;
                }
                $('#' + searchButtonId).css({ 'left': $(element).width() + leftOffset + 'px' });
            }

            // add instructional text
            let instructionId = (uniqueId !== '' ? uniqueId : elementId) + 'Instructions';

            if (settings.isManualTrigger && $(element).closest('.ah-ta-container').find('.ah-ta-instructions').length === 0) {
                safeFind(element).after('<div id="' + instructionId + '" data-supplemental-id="' + settings.supplementalId + '" class="ah-ta-instructions" style="visibility:hidden; overflow:visible; width:' + $(element).width() + 'px;">Press Enter after typing 3 characters to search</div>');
            }

            // if there is an advanced search button, attempt to move it to the correct location (there should be a small gap in between the text field and the search button)
            let advSearchBtn = $(element).closest('.ah-ta-container').find('.ah-ta-btn-adv-search');
            if (advSearchBtn && $(advSearchBtn).length > 0) {
                $(advSearchBtn).css({ 'left': $(element).outerWidth() + 1 + 'px' });
            }

            // if there is an info icon, attempt to move it to the correct location after the text field (and also after the search button if it exists)
            let infoIcon = $(element).closest('.ah-ta-container').find('.ah-ta-info-icon');
            if (infoIcon && $(infoIcon).length > 0) {
                $(infoIcon).css({ 'left': $(element).outerWidth() - 5 + 'px' });
            }
        });

        // listen for clicks on the search button
        /* NOTE: for now we are not using the search button, so commenting out (but keeping for reference in case we need it again) NOSONAR
        $('.ah-ta-search-btn').off('click').on('click', function (e) {
            _logDebug('triggerSearch() for ID [' + e.currentTarget.id + ']', { e: e });
            let textField = $(e.currentTarget).parent().find('input[type="text"]');

            if (!($(textField).parent().hasClass('acontainer'))) {
                $(textField).wrap("<div class='acontainer'></div>");
            }

            This.processInput($(textField)[0]);
        });
        */
        // END A11Y FIXES

        // autocomplete key press
        $(document).off('keyup', This.selector).on('keyup', This.selector, function (e) {
            _logDebug('keyup for ID [' + e.target.id + ']', { settings: settings });

            curTxtBx = this;
            el.ddDiv = $(this).closest('.acontainer').find('.adropdown');
            el.ddTable = $(this).closest('.acontainer').find('#providerMainGrid');

            //return if up/down/return key
            if ((e.keyCode < 46 || e.keyCode > 105) && keyCodes.indexOf(e.keyCode) <= -1) {
                e.preventDefault();
                return;
            }

            //delay for 1 second: wait for user to finish typing
            if (isSearch && (e.keyCode === A11yUtil.KEYCODES.enter || e.keyCode === A11yUtil.KEYCODES.down)) {
                _logDebug('keycode ENTER/DOWN ARROW for ID [' + options.id + ']');
                This.processInput(this);
            } else if (
                ($.trim($(this).val()).length < settings.minChar) ||
                ($.trim($(this).val()).indexOf('-') === 1 && $.trim(This.val()).length < settings.minChar + 2) ||
                (e.keyCode !== A11yUtil.KEYCODES.up && e.keyCode !== A11yUtil.KEYCODES.down && e.keyCode !== A11yUtil.KEYCODES.enter)
            ) {
                This.hideDropDown(this, e);
                return;
            } else {
                // do nothing, this is here for Sonar
            }

            if (e.keyCode === A11yUtil.KEYCODES.up || e.keyCode === A11yUtil.KEYCODES.down) {
                e.preventDefault();
            }

            if (($("#" + this.id, "#AuthDecisionGrid").length > 0) || ($("#" + this.id, "#AuthTransportationGrid").length > 0) || ($("#" + this.id, "#divExternalRelatedClaims").length > 0)) {
                $(this).closest('.acontainer').find('.adropdown').offset({ top: $(this).closest('.acontainer').offset().top + $(this).outerHeight(), left: $(this).closest('.acontainer').offset().left });
            }
        });

        // textbox focus event
        $(document).off('focusin', This.selector).on('focusin', This.selector, function (e) {
            _logDebug('focusin for ID [' + e.target.id + ']', { e: e, selector: This.selector, settings: settings });

            if (!($(this).parent().hasClass('acontainer'))) {
                $(this).wrap("<div class='acontainer'></div>");
                $(this).focus();
            }
            $($(this).parent()).prev('.acontainer').remove();

            if ($.isFunction(settings.focusinCallback)) {
                settings.focusinCallback.call(this);
            }

            if (settings.isManualTrigger) {
                $(this).closest('.ah-ta-container').find('.ah-ta-instructions').css('visibility', 'visible');
            } else if (settings.noteHtml && settings.noteHtml !== "") {
                $(this).closest('.acontainer').before(settings.noteHtml);
            } else {
                // do nothing, this is here for Sonar
            }
        });

        // process input
        This.processInput = function (curObj) {
            _logDebug('processInput() for ID [' + curObj.id + ']', { curObj: curObj });

            let settings = _getSettings(curObj);

            if (!settings) {
                DevUtils.logError('processInput(): cannot find settings on curObj');
                return;
            }

            cols = settings.columns.length;

            el = {
                ddDiv: $("<div>", { class: "adropdown ah-ta-modal", role: 'dialog', 'aria-modal': 'true', 'aria-label': 'search results' }),    // for a11y, turn this into a modal dialog
                ddTable: $("<table></table>", { id: 'providerMainGrid', style: "width:" + settings.width, cellspacing: '0', role: "table" }),
                ddTableCaption: $("<caption class='no-records-found'>" + settings.norecord + "</caption>"),
                ddSpan: $("<img id='SmartSearchLoader' src='StaticContents/images/DotLoader.gif'>"),
                // for a11y, add sr-only text with role=status:
                ddStatus: $("<span role='status' id='SmartSearchLoaderStatus' aria-live='assertive' class='sr-only'></span>"),
                divcontract: $('<div id="contractGridDiv" class="ProviderSearch-Container"  style="display: none;overflow: auto;z-index: 12;position: absolute;"><div class="primaryColor" id="contractGridCaption" style="font-weight: bold; padding: 5px; font- size: 13px;"></div><div class="Provider-Contract-Grid" id="contractGridDivContainer" style="font-size:13px !important;"></div></div>'),
                // for a11y, add close button to the modal dialog:
                ddModalHeader: $('<div class="ah-modal-header" style="display:none"><h2 class="ah-header-no-style">' + settings.dataType + ' Search Results</h2><button class="ta-close-btn" aria-label="close"><i class="far fa-close" aria-hidden="true"></i></button><div class= "ah-modal-instructions"> ' + settings.instructionalText + '</div></div>'),
            };

            if (curObj && ($(curObj).closest('.acontainer').find('.adropdown')).length === 0) {
                // append div after the textbox

                el.ddTable.append(el.ddTableCaption);
                let header = "<thead style='display:block;width:100%'><tr>";
                for (let i = 0; i <= cols - 1; i++) {
                    header = header + "<th style='width:" + settings.columns[i].Width + "px;'>" + settings.columns[i].Title + "</th>";
                }
                header = header + "</thead></tr>";
                el.ddTable.append(header);
                el.ddDiv.append(el.ddTable);
                if (isProviderQuickSearchExpandView) {
                    el.ddDiv.append(el.divcontract);
                }
                $(curObj).after(el.ddDiv);
            }
            el.ddDiv = $(curObj).closest('.acontainer').find('.adropdown');
            el.ddTable = $(curObj).closest('.acontainer').find('#providerMainGrid');
            el.ddTableCaption = el.ddTable.find('caption');

            let pcsFlg = false;
            let txt = $.trim($(curObj).val());
            pcsFlg = txt !== '';
            if (pcsFlg) {
                pcsFlg = txt.length >= settings.minChar;
            }

            if (pcsFlg) {
                pcsFlg = txt.indexOf('-') === 1 ? txt.length >= settings.minChar + 2 : true;
            }

            if (!pcsFlg) {
                This.hideDropDown($(curObj));
                return;
            }
            if ($(curObj).closest('.acontainer').find('.ah-modal-header').length === 0) {
                el.ddDiv.prepend(el.ddModalHeader);
            }
            // hide no record found message
            el.ddTableCaption.hide();

            if (curObj && ($(curObj).closest('.acontainer').find('#SmartSearchLoader')).length === 0) {
                $(curObj).after(el.ddSpan).after(el.ddStatus);
                setTimeout(function () {
                    $(curObj).closest('.acontainer').find('#SmartSearchLoaderStatus').text('Results loading');
                }, 200);
            }

            if (settings.ajax != null) {
                let tempData = null;
                if ($.isFunction(settings.ajax.data)) {
                    let provType = $(curObj).closest('.ProviderDiv').find('#ddlProvVal').val();
                    if ($(curObj).closest('#AuthInit_2_2.Accordion').length > 0) {
                        provType = $(curObj).closest('.ProviderDiv').find('.ddlProvVal').val();
                    }
                    tempData = settings.ajax.data.call(this, provType);
                } else {
                    tempData = settings.ajax.data;
                }

                // get json data
                $.ajax({
                    type: settings.ajax.type || 'GET',
                    dataType: 'json',
                    contentType: settings.ajax.contentType || 'application/json; charset=utf-8',
                    headers: settings.ajax.headers || { 'Content-Type': 'application/x-www-form-urlencoded' },
                    data: tempData || null,
                    url: settings.ajax.url,
                    success: function (jsonData) {
                        if (settings.ajax.success == null || settings.ajax.success === "" || (typeof settings.ajax.success === "undefined")) {
                            This.jsonParser(jsonData, curObj);
                        } else {
                            if ($.isFunction(settings.ajax.success)) {
                                let data = settings.ajax.success.call(this, jsonData);
                                This.jsonParser(data, curObj);
                            }
                        }

                        // for a11y, move the caption to the bottom of the table so it is in logical DOM order
                        el.ddTable.append(el.ddTableCaption);
                    },
                    error: function (xhr) {
                        el.ddSpan.remove();
                        DevUtils.logError('Error fetching search results: [' + xhr.status + ' ' + xhr.statusText + ': thrownError ' + xhr.thrownError + ']');
                        alert('Error while fetching search results');
                    }
                });
            } else if ($.isFunction(settings.data)) {
                let data = settings.data.call(this);
                This.jsonParser(data, curObj);
            } else {
                // default function - do nothing
            }
        };

        // textbox blur event
        $(document).off('focusout', This.selector).on('focusout', This.selector, function (e) {
            _logDebug('focusout for textfield ID [' + e.target.id + ']', { e: e, settings: settings, selector: This.selector });
            e.stopPropagation();

            // hide the instructional text when focus is lost
            $(this).closest('.ah-ta-container').find('.ah-ta-instructions').css('visibility', 'hidden');

            // clear if the text value is invalid
            if ((!$(e.relatedTarget).is($('.ah-ta-search-btn'))) && (!$(e.relatedTarget).is($('tr.selected'))) && $(this).val() !== $(this).attr("title") && $(this).val() !== null && $(this).val() !== undefined) {
                _logVerbose('clearing search field from focusout on textfield');
                clearSearchField($(this));
            }

            if ($.isFunction(settings.focusoutCallback)) {
                settings.focusoutCallback.call(this);
            }
        });

        // search button blur event
        /* NOTE: for now we are not using the search button, so commenting out (but keeping for reference in case we need it again) NOSONAR
        $('.ah-ta-search-btn').off('focusout').on('focusout', function (e) {
            _logDebug('focusout for search button ID [' + e.target.id + ']', { e: e, settings: settings });
            e.stopPropagation();

            // find the parent div associated with this search button
            let taContainer = $(this).closest('.ah-ta-container');
            // find the input element associated with the container
            let inputElem = $(taContainer).find('.acontainer input[type="text"]');

            // if relatedTarget is not the tautocomplete textfield or the search results modal, then find the text field and clear it if it is not a selected value
            if (!$(e.relatedTarget).is($(taContainer).find('.ah-ta-container .acontainer input')) && !$(e.relatedTarget).is($('tr.selected'))) {
                _logVerbose('clearing search field from focusout on search button');

                // check if the title of the input elem equals the current val (if it does, we have a valid value so don't clear it)
                if ($(inputElem).val() !== $(inputElem).attr('title')) {
                    clearSearchField(inputElem);
                }
            }

            if ($.isFunction(settings.focusoutCallback)) {
                settings.focusoutCallback.call(inputElem);
            }
        });
        */

        // modal search results blur event
        $(document).off('focusout', '.adropdown tr[role="button"]').on('focusout', '.adropdown tr[role="button"]', function (e) {
            _logVerbose('focusout for search results modal ID [' + e.target.id + ']', { e: e, settings: settings });
            e.stopPropagation();

            // find the parent div associated with this modal
            let taContainer = $(this).closest('.ah-ta-container');
            // find the input element associated with the container
            let inputElem = $(taContainer).find('.acontainer input[type="text"]');

            // if relatedTarget is not the tautocomplete textfield or another search result or the modal close button, then find the text field and clear it if it is not a selected value
            if (!$(e.relatedTarget).is($(taContainer).find('.ah-ta-container .acontainer input')) && !$(e.relatedTarget).is($('tr[role="button"]')) && !$(e.relatedTarget).is($('.ah-modal-header button'))) {
                _logVerbose('clearing search field from focusout on search results');

                // check if the title of the input elem equals the current val (if it does, we have a valid value so don't clear it)
                if ($(inputElem).val() !== $(inputElem).attr('title')) {
                    clearSearchField(inputElem);
                }
            }

            if ($.isFunction(settings.focusoutCallback)) {
                settings.focusoutCallback.call(inputElem);
            }
        });

        This.select = function (curObj) {
            _logDebug('select() for ID [' + curObj.id + ']');

            let settings = _getSettings(curObj);

            el.ddDiv = $(curObj).closest('.acontainer').find('.adropdown');
            el.ddTable = $(curObj).closest('.acontainer').find('#providerMainGrid');
            let selected = el.ddTable.find("tbody").find(".selected");
            selectedData = selected.data('rowdata');
            if (ToValue(selectedData, null) !== null) {
                $(curObj).data("id", selectedData[settings.columnToSelectId]);
                $(curObj).attr("title", selectedData[settings.columnToSelectText]);

                selectedData = Array.isArray(selectedData) ? selectedData[0] : selectedData;
                if (event.target.id === 'viewNetworkContractbuttonHover') {
                    hasClickedViewNetworkContractButton = true;
                    $("#hdnProvSearchValue").val($(curObj).val());
                    event.preventDefault();
                }
                else {
                    This.hideDropDown(curObj);
                }
                This.onChange(curObj, selectedData);

                // for a11y, we need to set focus to the autocomplete dropdown after the user selects
                // an item from the search results; however, if user has already explicitly
                // focused on another element, do not steal focus away from that element
                setTimeout(function () {
                    var focused = document.activeElement;
                    if (!focused || focused == document.body) {
                        A11yUtil.setFocus($(curObj)[0]);
                    }
                }, 300);
            }
        };

        This.onChange = function (curObj, selectedData) {
            _logDebug('onChange() for ID [' + curObj.id + ']');

            let settings = _getSettings(curObj);

            // onchange callback function
            if (event.target.id === 'viewNetworkContractbuttonHover') {
                hasClickedViewNetworkContractButton = true;
                if (ToValue(selectedData, null) !== null) {
                    showProviderNetworks(selectedData.PhysicianId);
                }
            } else if (settings && $.isFunction(settings.onchange)) {
                if (selectedData && selectedData != null) {
                    $(curObj).val(selectedData[settings.columnToSelectText]);
                    $(curObj).AhsSetAttr("title", selectedData[settings.columnToSelectText]);
                    $(curObj).data("id", selectedData[settings.columnToSelectId]);
                } else {
                    $(curObj).removeAttr('title');
                }
                setTimeout(function () {
                    settings.onchange.call(this, selectedData, curObj);                    
                });
            } else {
                /*default function for onchange   */
            }
        };

        This.hideDropDown = function (curObj, event) {
            _logDebug('hideDropDown() for ID [' + curObj.id + ']');

            if (event && (event.target.id === 'viewNetworkContractbuttonHover')) {
                hasClickedViewNetworkContractButton = true;
                event.preventDefault();
            } else {
                isSearch = true;
                el.ddDiv = $(curObj).closest('.acontainer').find('.adropdown');
                el.ddTable = $(curObj).closest('.acontainer').find('#providerMainGrid');
                el.ddTableCaption = el.ddTable.find('caption');
                el.ddModalHeader = el.ddDiv.find('.ah-modal-header');

                el.ddTable.find(".selected").removeClass("selected");
                el.ddTable.hide();
                $(curObj).removeClass("inputfocus");
                el.ddDiv.removeClass("highlight");
                el.ddDiv.remove();
                el.ddTableCaption.hide();
                el.ddModalHeader.remove();
            }

            // If we are in a dialog, recalculate the tab stops after hiding the results dialog (which is also a modal)
            let modalContainer = $(curObj).closest('.ah-modal');
            if (modalContainer.length > 0) {
                A11yModal.trapFocusInModal(modalContainer.attr('id'));
            }
        };

        This.showDropDown = function (curObj) {
            _logDebug('showDropDown() for ID [' + curObj.id + ']', { curObj: curObj });

            isSearch = false;
            el.ddDiv = $(curObj).closest('.acontainer').find('.adropdown');
            el.ddModalHeader = el.ddDiv.find('.ah-modal-header');
            el.ddTable = $(curObj).closest('.acontainer').find('#providerMainGrid');

            let cssTop = "1px 1px 0px 1px";
            let cssBottom = "1px 1px 1px 1px";

            el.ddTable.find("tbody").css({ "max-height": "300px", "overflow-y": "auto", "display": "block", "width": "100%" });

            // reset div top, left and margin
            if ($("#AuthDecisionGrid").is(":visible") === false || $("#AuthTransportationGrid").is(":visible") === false ) {
                el.ddDiv.css("top", $(curObj).outerHeight() + "px");
                el.ddDiv.css("left", "0px");
            }

            el.ddTable.css("margin", cssTop);

            $(curObj).addClass("inputfocus");
            el.ddDiv.addClass("highlight");
            el.ddTable.show();
            el.ddModalHeader.show();

            // adjust div top according to the visibility
            let isModal = $(el.ddDiv).closest('.ah-modal').length > 0;

            if (!isDivHeightVisible(el.ddDiv) && !($("#AuthDecisionGrid").is(":visible") || $("#AuthTransportationGrid").is(":visible"))) {
                // if we get inside here, it means the dropdown is being moved *above* the input field
                el.ddDiv.css("top", -1 * (el.ddTable.height() + el.ddModalHeader.outerHeight() + 4) + "px");
                el.ddTable.css("margin", cssBottom);

                if (!isDivHeightVisible(el.ddDiv)) {
                    el.ddDiv.css("top", $(curObj).outerHeight() + "px");
                    el.ddTable.css("margin", cssTop);
                    $('html, body').animate({
                        scrollTop: (el.ddDiv.offset().top - 60)
                    }, 250);
                }
            } else if (isModal) {
                el.ddDiv.css("top", $(curObj).outerHeight() + "px");
                el.ddTable.css("margin", cssTop);
            } else {
                // do nothing, this is here for Sonar
            }

            // adjust div left according to the visibility
            let isLeftMenuExpanded = $(".GLB-AsideLeft.active").length > 0;
            //Removing 'active' class for css adjustment on 'auto complete drop down'
            if (isLeftMenuExpanded) {
                $(".GLB-AsideLeft.active").removeClass("active");
            }
            let subValue;
            if (PHNavID === '1') {
                if (!isDivWidthVisible(el.ddDiv)) {
                    if ((!$("#AuthDecisionGrid").is(":visible") || $(curObj).closest('.ah-modal').length > 0) || (!$("#AuthTransportationGrid").is(":visible") || $(curObj).closest('.ah-modal').length > 0) ) {
                        subValue = el.ddDiv.offset().left < 320 ? 650 : 30;
                        el.ddDiv.css("left", "-" + (el.ddTable.width() - $(curObj).width() - subValue) + "px");
                    }
                    else {
                        el.ddTable.css("width", (el.ddTable.width() - 160) + "px");
                    }
                }
            } else {
                if (!isDivWidthVisible(el.ddDiv)) {
                    if ((!$("#AuthDecisionGrid").is(":visible") || $(curObj).closest('.ah-modal').length > 0) || (!$("#AuthTransportationGrid").is(":visible") || $(curObj).closest('.ah-modal').length > 0)) {
                        subValue = el.ddDiv.offset().left < 320 ? 576 : 30;
                        el.ddDiv.css("left", "-" + (el.ddTable.width() - $(curObj).width() - subValue) + "px");
                    }
                    else {
                        el.ddTable.css("width", (el.ddTable.width() - 160) + "px");
                    }
                }
            }
            //Again adding the 'active' class after css adjustment as like previous state.
            if (isLeftMenuExpanded) {
                $(".GLB-AsideLeft").addClass("active");
            }

            if ($("tbody", el.ddTable).prop("scrollHeight") > $("tbody", el.ddTable).height()) {
                $("thead", el.ddTable).width("100%");
            }

            let firstRow = el.ddTable.find("tbody").find("tr:first");
            $(firstRow).addClass('selected');

            // A11y change to create the tabbing loop within the modal dialog
            if (!$(curObj).closest('#viewContractbuttonHover').is(":visible") && isProviderQuickSearchExpandView) {
                A11yModal.trapFocusInModal(el.ddDiv[0], '.ta-close-btn,span');
            }
            else {
                A11yModal.trapFocusInModal(el.ddDiv[0]);
            }

            // A11y change to set focus to first row of table, or the close button of the modal if no results
            if ($(firstRow).length > 0) {
                A11yUtil.setFocus($(firstRow)[0]);
            } else {
                A11yUtil.setFocus($('.ta-close-btn')[0]);
            }

            // closing tautocomplete dropdown if another is opened in Auth entry page and Add new decision popups
            if ($(".adropdown").length > 1) {
                let hidingDD = $($(".adropdown")[0].closest('.acontainer')).find('.ah-ta-input');
                let hidingDD1 = $($(".adropdown")[1].closest('.acontainer')).find('.ah-ta-input');
                $(curObj).attr('id') === $(hidingDD).attr('id') ? This.hideDropDown(hidingDD1) : This.hideDropDown(hidingDD);
            }

             //listener for closing the dialog when clicked outside of it
            $(document).on('click.tautocomplete', function (e) {
                let resultsContainer = $(curObj).closest('.acontainer').find('.adropdown');
                let target = $(e.target);
                let closestTarget = target.closest('.adropdown');
                let authProviderSelectedValue = "";
                let agProviderSelectedValue = "";
                let agProviderSelectedTextValue = "";

                authProviderSelectedValue = $(curObj).closest('.ProviderDiv').find('#HdnPhysicianId').val();
                agProviderSelectedValue = $(curObj).closest('.AgProviderDiv').find('#HdnPhysicianId').val();
                agProviderSelectedTextValue = $(curObj).closest('.AgProviderDiv').find('#HdnPhysicianIdValue').val();

                if (!target.is(resultsContainer) && !closestTarget.is(resultsContainer) && !target.is($('.ah-ta-search-btn')) && !target.is($('.ah-ta-search-btn i'))
                    && e.target.id !== 'networkCancel' && !hasClickedViewNetworkContractButton) {
                    // cicked outside of dialog... close it:

                    This.hideDropDown(curObj, e);
                    // dispose of the click event handler after closing the dropdown
                    $(document).off('click.tautocomplete');
                }

                if (e.target.id === 'networkCancel' || hasClickedViewNetworkContractButton) {
                    $(curObj).val($("#hdnProvSearchValue").val());
                }
                else {
                    if (($(curObj).closest('.TextSsProviderName').length > 0) && $.fn.isNullOrEmpty(authProviderSelectedValue)
                        && $.fn.isNullOrEmpty(agProviderSelectedValue) && $.fn.isNullOrEmpty(agProviderSelectedTextValue)) {
                        $(curObj).val("");
                    }
                }
                hasClickedViewNetworkContractButton = false;
            });
        };

        This.jsonParser = function (jsonData, curObj) {
            _logDebug('jsonParser() for ID [' + curObj.id + ']', { curObj: curObj });

            let settings = _getSettings(curObj);
            cols = settings.columns.length;

            el.ddDiv = $(curObj).closest('.acontainer').find('.adropdown');
            el.ddSpan = $(curObj).closest('.acontainer').find('img');

            el.ddStatus = $(curObj).closest('.acontainer').find('span[role="status"]');
            el.ddTable = $(curObj).closest('.acontainer').find('#providerMainGrid');
            el.ddTableCaption = el.ddTable.find('caption');
            el.ddCloseBtn = el.ddDiv.find('.ah-modal-header button');

            let tbody = el.ddTable.find("tbody");

            try {
                dataList = jsonData;
                let dataById = jQuery.grep(dataList, function (a) {
                    return a[settings.tabEnabledColumn] == srchValb4Tab;    // NOSONAR - not sure if using '===' will break this
                });

                // remove the Loading indicators from DOM
                el.ddSpan.remove();
                el.ddStatus.remove();

                if (dataById.length === 1 && IsTab) {
                    This.onChange(curObj, dataById[0]);
                    IsTab = false;
                    return;
                } else if (dataById.length !== 1 && IsTab) {
                    IsTab = false;
                    return;
                } else {
                    // do nothing, this is here for Sonar
                }

                // remove all rows from the table
                tbody.html('');

                let i = 0;
                let j = 0;
                let row = null;
                let cell = null;

                if (jsonData != null) {
                    for (i; i < jsonData.length; i++) {
                        // display only 15 rows of data
                        if (i >= 20) {
                            continue;   // NOSONAR (Sonar saying to remove the continue... too risky to remove)
                        }

                        let obj = jsonData[i];
                        row = "";
                        j = 0;

                        for (let key in obj) {  // NOSONAR
                            // return on column count
                            if (j < cols) {

                                if (obj[settings.columns[j].ItemKey] != null && obj[settings.columns[j].ItemKey] !== "") {
                                    cell = obj[settings.columns[j].ItemKey] + '';
                                } else if (settings.columns[j].ItemNull) {
                                    cell = settings.columns[j].ItemNull + '';
                                } else {
                                    cell = 'N/A';
                                }

                                if (settings.columns[j].ItemDataType !== null && settings.columns[j].ItemDataType !== undefined && settings.columns[j].ItemDataType.toLowerCase() === 'jsondate' && cell !== '' && cell !== 'N/A' && cell !== settings.columns[j].ItemNull) {
                                    cell = formatToDateValidation(new Date(parseInt(cell.substr(6), 10)));
                                }

                                if (window.top.$(".InAuthPage").length > 0 && settings.columns[j].ItemKey === 'ProviderFullNameActual' && $(curObj).hasClass('TextSsProviderName')) {
                                    if (obj.IsTermedProvider) {
                                        row = row + "<td class='td-visible' title=\"" + escapeHtml(cell) + "\" style='width:" + settings.columns[j].Width + "px;max-width:" + settings.columns[j].Width + "px;" + "'><span class='red f14' title='Provider Contract Terminated'><i class='fa fa-exclamation-circle'></i></span>" + escapeHtml(cell) + "</td>";
                                    } else {
                                        row = row + "<td class='td-visible' title=\"" + escapeHtml(cell) + "\" style='width:" + settings.columns[j].Width + "px;max-width:" + settings.columns[j].Width + "px;" + "padding-left:15px;'>" + escapeHtml(cell) + "</td>";
                                    }
                                } else if (settings.columns[j].IsViewlink ? true : false) {
                                    row = row + "<td class='td-visible' title=\"" + settings.columns[j].Title + "\" style='width:" + settings.columns[j].Width + "px;max-width:" + settings.columns[j].Width + "px;" + "'>" + settings.columns[j].IsViewlink.replaceAll('#PhysicianId#', obj["PhysicianId"]).replace('#ProviderName#', obj["ProviderFullNameActual"]) + "</td>";
                                } else {
                                    row = row + "<td class='td-visible' title=\"" + escapeHtml(cell) + "\" style='width:" + settings.columns[j].Width + "px;max-width:" + settings.columns[j].Width + "px;" + "'>" + escapeHtml(cell) + "</td>";
                                }
                            } else {
                                continue;   // NOSONAR (Sonar saying to remove the continue... too risky to remove)
                            }

                            j++;
                        }

                        // append row to the table
                        // A11y changes made to turn the entire table row into an actionable button
                        let tr = $("<tr class='ta-row-button'></tr>", { style: "width:100%" });
                        tr.data('rowdata', obj).html(row);
                        el.ddTable.append(tr);
                    }
                }

                // show no records exists
                if (i === 0) {
                    el.ddTableCaption.html(settings.norecord).show();
                    el.ddTableCaption[0].style.removeProperty('text-align');
                } else if (settings.disclaimerHtml && settings.disclaimerHtml !== "") {
                    el.ddTableCaption.html(settings.disclaimerHtml).css("text-align", "left").show();
                } else {
                    // do nothing (this is here for Sonar)
                }

                // hide columns (e.g. primary key cols)
                for (let z = 0; z < settings.hide.length && z < cols; z++) {
                    if (!settings.hide[z]) {
                        el.ddTable.find('td:nth-child(' + (z + 1) + ')').hide().removeClass('td-visible');
                        el.ddTable.find('th:nth-child(' + (z + 1) + ')').hide();
                    }
                }

                // A11y change to set scope attr on header's cols and rows
                el.ddTable.find('thead tr th').attr('scope', 'col');    // each th in the table header needs scope="col" attr

                el.ddTable.find('tbody tr').each(function (index, trElem) {
                    // find the first visible <td> element and change it to a <th> and turn it into a button
                    let tdElem = $(trElem).find('td.td-visible').get(0);

                    if (tdElem && $(tdElem).length > 0) {
                        let tdText = $(tdElem).text();
                        $(tdElem).attr('scope', 'row').text('').append('<span role="button" tabindex="0">' + escapeHtml(tdText) + '</span>');
                        $(trElem).find('td[scope="row"]').changeElementType('th');
                    }
                });

                // A11y changes to listen for ENTER and SPACEBAR events on the table row (in addition to the legacy mouseclick)
                el.ddTable.undelegate('tr', 'mousedown keydown').delegate('tr', 'mousedown keydown', function (event) {
                    _logDebug('table row mousedown event [' + event.type + ']', { 'event.which': event.which, 'event.keyCode': event.keyCode });

                    if (event.which === A11yUtil.MOUSECLICKS.LEFT || event.keyCode === A11yUtil.KEYCODES.enter || event.keyCode === A11yUtil.KEYCODES.spacebar) {
                        // only select when the LEFT mouse button clicked, the ENTER or SPACEBAR key is hit
                        el.ddTable.find(".selected").removeClass("selected");
                        $(this).addClass("selected");

                        This.select($(this).closest('.acontainer').find('input[type="text"]'));
                    } else if (event.keyCode === A11yUtil.KEYCODES.escape) {
                        This.hideDropDown($(curObj), event);
                        A11yUtil.setFocus($(curObj)[0]);
                    } else {
                        // do nothing (this is here for Sonar)
                    }
                });

                // A11y change to listen for click/enter on search results modal close button
                el.ddCloseBtn.off('click').on('click', function (e) {
                    This.hideDropDown($(curObj), e);
                    A11yUtil.setFocus($(curObj)[0], 1000);
                });

                This.showDropDown(curObj);

                let selected = tbody.find(".selected");
                if (selected.offset()) {
                    tbody.scrollTop(selected.offset().top + tbody.scrollTop() - tbody.offset().top - 20);
                }
            } catch (e) {
                DevUtils.logError(e, 'A11yTAutocomplete.jsonParser()');
            }
        };

        return tautocomplete;
    };
}(jQuery));
